import type { ScaleOptions } from '@uipath/apollo-lab';

export function formatScaleX(): ScaleOptions {
    return { type: 'band' };
}
